<div class="tw-p-4">
  <p class="tw-text-base">
    <b>{{totalRecords}}</b> Used <b>{{category | titlecase}}</b> cars for subscription <b>{{location ? 'in '+ (location
      |
      titlecase) :
      ''}}</b> | Pumpumpum
  </p>
  <p>Drive it like you own it!</p>
  <div class="tw-text-base tw-mt-2" [ngClass]="showMore ? '': 'tw-hidden'">

    <br>
    <p>PumPumPum used car subscription service is available {{location ? 'in '+ (location|titlecase) : ''}}, where you
      can own a car on subscription basis at zero downpayment. Choose from our wide range of second hand {{category |
      titlecase}} cars on subscription and get your dream car delivered to your doorstep.</p>

    <br>
    <p><b>PumPumPum helps you subscribe a {{category | titlecase}} car {{location ? 'in '+ (location|titlecase) : ''}}
        in just three simple steps:</b>
    </p>
    <ol class="tw-mt-2">
      <li><b>1. Find the right car:</b> Choose from a wide range of PPP Assured cars with 300+ quality checks and select
        your subscription or lease duration, starting from 6 months.</li>
      <li><b>2. Get online approval:</b> Submit your documents &amp; get online eligibility approval.</li>
      <li><b>3. Drive worry free:</b> Drive and enjoy. We've got you covered for insurance, service, and maintenance
      </li>
    </ol>

    <p>Once your current subscription is over you can easily upgrade your car or even continue with the same car with
      our easy subscription extensions.</p>

    <br>
    <p><b>How PumPumPum is better than other {{(location || category)|titlecase}} car rental, lease, and subscription
        services?</b>
    </p>
    <ol class="tw-mt-2">
      <li>
        <b>1. Private Number Plate Cars:</b>
        We provide you with the certified pre-owned car of your choice with a private number plate without any branding
        which gives you the true meaning of ownership. Most of the other car lease or rental companies will provide a
        commercial black/yellow number plate vehicle with their branding. Also, commercial number plate cars are
        expensive owing to interstate toll taxes.
      </li>
      <li>
        <b>2. Only the best cars:</b> PumPumPum certified used cars are all well maintained and delivered to our
        customers after 300+ inspection checks
      </li>

      <li>
        <b>3. End-to-end warranty:</b> PumPumPum used car subscription covers every type of non-accidental part failure
        and limits your exposure.
      </li>
      <li>
        <b>4. Zero Dep Insurance Coverage</b> We've got you covered. All PumPumPum used cars come with Zero Dep
        Insurance coverage, which means now you can drive worry free.
      </li>
      <li>
        <b>5. Free Service & Maintenance:</b> All the regular wear and tear expenses regarding the car are taken care of
        by PumPumPum thereby making your experience hassle free.
      </li>
      <li>
        <b>6. Pick Up and Drop:</b> PumPumPum offers free pick and drop service for all planned and unplanned service
        and maintenance of the subscribed cars keeping your experience hassle free.
      </li>
      <li>
        <b>7. 24X7 road side assistance:</b> PumPumPum used car subscription comes with 24X7 roadside assistance. Our
        service team and partners are available for you round the clock to help you whenever the need arises.
      </li>
    </ol>
    <br>
    <p *ngIf="location">Join hundreds of smart car subscribers from all parts of {{location ? 'in '+
      (location|titlecase) : ''}}
      like: {{locations}}</p>

  </div>

  <p class="tw-cursor-pointer tw-text-sm tw-text-yellow" (click)="showMore=!showMore">
    Show {{showMore ? 'less': 'more'}}...
  </p>
</div>